const SelectModuleInitialState = {
  option: "Sales",
};

export default SelectModuleInitialState;
